import Logo from "../../assets/LOGO.png";
import KalbuPasirinkimas from '../KalbuPasirinkimas';
import { useTranslation } from 'react-i18next';
import { Box } from "@mui/material";

export const LoginTemplate = ({ title, children }) => {
    const { t } = useTranslation();

    return (
        <div className='prisijungimoLangas'>
            <div className='prisijungimoKalbos'>
                <KalbuPasirinkimas
                    className='prisijungimoKalbos'
                    options={t('kalba')}
                    optionsText={t('kalba_text')}
                />
            </div>
            <Box sx={{ p: 4, display: { xs: "block", sm: "none"} }}>
                {title}
            </Box>
            <div className='lentele'>
                <div className='lenteleVidus'>
                    <Box sx={{ display: { xs: "none", sm: "block"} }}>
                        {title}
                    </Box>
                    {children}
                </div>
            </div>
            <a href='http://www.ivairove.lt' target="_blank" className='loginLogoCont' rel="noreferrer">
                <img className='loginLogo' src={Logo} alt='logo' />
            </a>
        </div>
    )
}


